import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  'photoLoaded': false,
  'photoById': {},
}

const photoSlice = createSlice({
  name: 'photo',
  initialState,
  reducers: {
    loadPhotos: (state, action) => {
      state.photoLoaded = true;
      state.photos = action.payload.photos;
      const photoById = {}
      action.payload.photos.map(photo => {
        photoById[photo["photo_id"]] = photo
        return null
      });
      state.photoById = photoById;
    },
    photoDeleted: (state, action) => {
      const photo = action.payload.photo;
      delete state.photoById[photo["photo_id"]];
    },
    photoUploaded: (state, action) => {
      const photo = action.payload.photo;
      state.photoById[photo["photo_id"]] = photo;
    },
    resetPhotos: (state) => {
      state.photoById = {}
      state.photoLoaded = false;
    }
  },
})

export const { loadPhotos, photoUploaded, photoDeleted, resetPhotos} = photoSlice.actions
export default photoSlice.reducer